
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

/**
 * Yeni sürüm yayınlandığında sayfayı BİR KEZ yeniler.
 *
 * NEDEN: Servis çalışanı `autoUpdate` ile kuruluyor, yani yeni sürüm arka
 * planda indirilip hemen etkinleşiyor. Ama AÇIK OLAN sayfa belleğindeki eski
 * JS ile çalışmaya devam ediyor; kullanıcı yeni sürümü ancak BİR SONRAKİ
 * açılışta görüyordu. Pratikte bu, her deploy'dan sonra "sert yenileme yapın"
 * demek anlamına geliyordu ve düzeltilen hatalar kullanıcıda düzelmiş
 * görünmüyordu.
 *
 * `controllerchange` yeni servis çalışanı denetimi devraldığında tetiklenir.
 * İLK KURULUMDA DA tetikleniyor (denetleyici yokken bir tane oluşuyor); o
 * durumda yenilemek gereksiz, o yüzden önceden bir denetleyici olup
 * olmadığına bakılıyor. `yenilendi` bayrağı da olası bir yenileme döngüsünü
 * kesiyor.
 */
if ('serviceWorker' in navigator) {
  const oncedenVardi = Boolean(navigator.serviceWorker.controller);
  let yenilendi = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!oncedenVardi || yenilendi) return;
    yenilendi = true;
    window.location.reload();
  });
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <App />
);
